import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=b29f5a2a&"
import script from "./LoginMessage.vue?vue&type=script&lang=js&"
export * from "./LoginMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports